import { Component, EventEmitter, Input, Output, ViewChild, ComponentFactoryResolver } from '@angular/core';
import { PopoverController, Popover, PopoverOptions, NavController, AlertController, LoadingController, Platform } from 'ionic-angular';
import { PopoverTemplateComponent } from '../popover-template/popover-template';
import { TypeServices } from '../../../utils/types';

import { ReservesProvider } from '../../../providers/reserves';
import { FieldsProvider } from '../../../providers/fields';
import { UserProvider } from '../../../providers/user';
import { C } from '../../../utils/constants';

// Animation
import { TimelineMax } from 'gsap';
import { NavigationProvider } from '../../../providers/navigation';

@Component({
    selector: 'i-mapa',
    templateUrl: 'i-mapa.html'
})
export class IMapaComponent{
    /* Map */
    @ViewChild('mapViewer') viewer: any;
    @ViewChild('mapContainer') mapContainer: any;
    @Input() area: string = '';
    @Output() pointClick: EventEmitter<any> = new EventEmitter();
    @Output() kioskReserve: EventEmitter<any> = new EventEmitter();

    /* Data */
    private data: any[] = [];
    private gymIndexedData: any[] = [];
    private indexedData: any[] = [];
    private mapZoomed: boolean = false;
    private blocks: any;
    private dots: any;
    private areasGroup: any;
    private dotsGroup: any;
    private maps: any;
    private mapDOM: any;
    private initialVB: string = '';
    private originalVB: any;
    private zoom: number;
    private point: any;
    private isPointerDown: boolean = false;
    private pointerOrigin: any;
    private viewBox: any;
    private pointerPosition: any;
    private pointerMoved: boolean = false;
    private refresh: boolean = false;
    private timeout: number = 10000;

    private user: any;
    public firebasePlugin;
    /* Animation */
    private timeline: TimelineMax;

    /* Popover */
    private currentPopover: Popover = null;

    constructor(
        public popoverCtrl: PopoverController,
        public factory: ComponentFactoryResolver,
        public platform: Platform,
        public reserves_m: ReservesProvider,
        public fields_m: FieldsProvider,
        public alertCtrl: AlertController,
        public loadingCtrl: LoadingController,
        public user_m: UserProvider,
        public navCtrl: NavController,
        public navigation: NavigationProvider
    ) {
        this.firebasePlugin = (<any>window).FirebasePlugin;
        this.zoom = 2;
        this.maps = {
            svg: C.MAP_APP_JUVENTUDE
        }

        let loader = this.loadingCtrl.create({
            content: "Aguarde...",
            spinner: 'crescent'
        });
        loader.present();

        this.user_m.get().then((user: any) => {
            this.user = user;
            Promise.all([
                this.reserves_m.getKiosks(),
                this.reserves_m.getSalons(),
                this.fields_m.getFields(user.sequency),
                this.reserves_m.getFitness(),
                this.reserves_m.getFreePools(),
                this.user_m.getTimeoutMapa()
            ]).then((data:any) => {
                this.timeout = data[5];
                let dataKiosks: any = data[0].filter((tab) => {
                    return tab.sequency == user.sequency;
                })
                let dataSalons: any = data[1].filter((tab) => {
                    return tab.sequency == user.sequency;
                })
                let gymData = data[3].filter((tab) => {
                    return tab.sequency == user.sequency;
                })

                let poolData = data[4].filter((tab) => {
                    return tab.sequency == user.sequency;
                })

                let pool = poolData[0].pools.filter(pool => {
                    return pool.id_service == 1056;
                });

                if (pool[0]){
                    this.gymIndexedData[pool[0].id_service] = pool[0];
                }

                gymData[0].items.forEach((item) => {
                    this.gymIndexedData[item.id] = item;
                })

                this.data = this.data.concat(dataKiosks[0].items, dataSalons[0].items, data[2]);
                this.indexedData = [];

                this.data.forEach((item) => {
                    this.indexedData[item.id] = item;
                })

                loader.dismiss();
                this.loadMap();
            });
        })
    }

    ngOnDestroy() {
        this.stopRefreshKiosks();
    }

    startRefreshKiosks() {
        this.refresh = true;
    }

    stopRefreshKiosks() {
        this.refresh = false;
    }

    async refreshKiosks() {
        if (this.refresh) {
            await this.reserves_m.getKiosks().then((data: any) => {
                let dataKiosks: any = data.filter((tab) => {
                    return tab.sequency == this.user.sequency;
                })

                dataKiosks[0].items.forEach(kiosk => {
                    this.indexedData[kiosk.id] = kiosk;
                });

                this.setKiosksStatus();

                console.log('Quiosques Atualizados!');
            })
        }

        setTimeout(() => {
            this.refreshKiosks();
        }, this.timeout);
    }

    loadMap() {
        this.timeline = new TimelineMax({paused: true});

        this.mapContainer.nativeElement.innerHTML = this.maps.svg;
        this.mapDOM = this.mapContainer.nativeElement.firstChild;
        this.areasGroup = this.mapDOM.querySelector('g[id="groups"]');
        this.dotsGroup = this.mapDOM.querySelector('g[id="dots"]');
        this.setKiosksStatus();

        this.originalVB = this.mapDOM.getAttribute('viewBox');
        let svgView = this.mapDOM.viewBox.baseVal;

        let viewWidth = this.mapContainer.nativeElement.clientWidth;
        let viewHeight = this.mapContainer.nativeElement.clientHeight;
        let x = Math.max(0, (parseFloat(svgView.width) / 2) - (parseFloat(viewWidth) / 2));
        let y = Math.max(0, (parseFloat(svgView.height) / 2) - (parseFloat(viewHeight) / 2));
        let viewString = x + ' ' + y + ' ' + viewWidth + ' ' + viewHeight;

        this.playAnimation(viewString, () => {
            this.initialVB = this.mapDOM.getAttribute('viewBox');

            this.bindPinEvents();
            this.bindAreaEvents();
        });
    }

    setKiosksStatus() {
        let kiosks = this.mapDOM.querySelectorAll('g[id="kiosks"] g[id^="kiosk_"]');
        kiosks.forEach(element => {
            let id = element.id.split('_')[1];

            if(this.indexedData[id]) {
                if (this.indexedData[id].status == 'available') {
                    element.setAttribute('fill', '#60b444');
                } else {
                    element.setAttribute('fill', '#b56969');
                }
            } else {
                element.setAttribute('fill', '#b56969');
            }
        });
    }

    playAnimation(vb: string, callback: any) {
        this.timeline.clear(true);
        this.timeline.to(this.mapDOM, 0.5, {
            attr: {
                viewBox: vb
            }
        })
        this.timeline.eventCallback('onComplete', callback)

        this.timeline.play();
    }

    chooseArea(e, item) {
        let itemBounds = item.getBBox();

        this.areasGroup.style.display = "none";
        this.dotsGroup.style.display = "block";

        console.log(itemBounds);
        let center = {
            x: (itemBounds.x+(itemBounds.width/2))-(250 / 2),
            y: (itemBounds.y+(itemBounds.height/2))-(300 / 2)
        }
        let viewString = center.x + ' ' + center.y + ' ' + 250 + ' ' + 300;

        this.playAnimation(viewString, () => {
            this.setInitials();
        });
        this.mapZoomed = true;
    }

    async openDetail(event, type, id) {
        let page, desc, title;
        let items = [];
        if (type == 'g') {
            title = 'Ginásio';
            this.gymIndexedData.forEach((service) => {
                let isPiscina = service.id_service ? true : false;
                if (isPiscina) {
                    service.id = service.id_service;
                }
                items.push({
                    id: service.id,
                    type: isPiscina ? TypeServices.Piscina : TypeServices.Academia,
                    status: service.status || '',
                    name: isPiscina ? 'P25 Livre' : service.title,
                    callback: () => {
                        if(typeof service == 'undefined') {
                            let alert = this.alertCtrl.create({
                                title: 'Aviso',
                                message: 'Você não pode ou não se encaixa no perfil para esta reserva',
                                buttons: ['Fechar']
                            })
                            alert.present();

                            return;
                        }

                        this.navCtrl.push(isPiscina ? 'ReservarPiscinasDetalhesPage' : 'ReservarAcademiaDetalhesPage', { item: service.id, pool: service.id, sequency: this.user.sequency }, { animate: true, direction: 'forward' });
                        this.currentPopover.dismiss();

                        return true;
                    }
                })
            })
        } else {
            let item = this.indexedData[id];
            title = item ? item.title : '';
            switch (type) {
                case TypeServices.Quiosque.toString():
                    page = 'ReservarQuiosquesDetalhesPage';

                    switch (item.status) {
                        case 'available':
                            desc = 'Disponível para reserva'
                            break;
                        case 'closed':
                            desc = 'Disponível para reserva às '+item.min_time_f;
                            break;
                        case 'locked':
                            desc =  'Disponível para reserva às '+item.min_time_f;
                            break;
                        case 'reserved':
                            desc = 'Reservado';
                            break;
                        case 'unavailable':
                            desc = 'Reservado às '+item.reserve_f+'. Disponível novamente a partir das 20:00h';
                            break;
                        case 'blocked':
                            desc = 'Você já possuí reservas';
                            break;
                        default:
                            desc = 'Informação indisponível no momento'
                            break;
                    }
                    break;

                case TypeServices.Quadras.toString():
                    page = 'ReservarQuadrasDetalhesPage';
                    desc = 'Prossiga para reservar a quadra acima.';
                    break;

                case TypeServices.Saloes.toString():
                    page = 'ReservarSaloesDetalhesPage';
                    desc = 'Prossiga para reservar o espaço acima';
                    break;

                default:
                    let alert = this.alertCtrl.create({
                        title: 'Aviso',
                        message: 'Local indisponível no momento',
                        buttons: ['Fechar']
                    });
                    alert.present();

                    return;
            }

            let serviceItem = {
                id: item.id,
                type: type,
                status: item.status || '',
                name: item.title,
                desc: desc,
                callback: () => {
                    if(typeof item == 'undefined') {
                        let alert = this.alertCtrl.create({
                            title: 'Aviso',
                            message: 'Você não pode ou não se encaixa no perfil para esta reserva',
                            buttons: ['Fechar']
                        })
                        alert.present();

                        return;
                    }

                    if (this.platform.is('cordova')) {
                        let eventParams = { reserva_id: item.id, reserva_nome: item.title };
                        console.log("Evento Firebase (reservas_mapa_aberto)", eventParams);
                        // this.firebasePlugin.logEvent("reservas_mapa_aberto", eventParams);
                    }

                    this.currentPopover.onDidDismiss(() => {
                        this.navCtrl.push(page, { item: item.id, sequency: this.user.sequency }, { animate: true, direction: 'forward' });
                    })

                    this.currentPopover.dismiss();

                    return true;
                }
            }

            items = [serviceItem];


            if (this.platform.is('cordova')) {
                let eventParams = { servico_id: serviceItem.id, servico_nome: serviceItem.name };
                console.log("Evento Firebase (mapa_ponto_aberto)", eventParams);
                // this.firebasePlugin.logEvent("mapa_ponto_aberto", eventParams);
            }

            this.pointClick.emit(serviceItem);
        }
        let newPopover = await this.popoverCtrl.create(PopoverTemplateComponent, {
            data: {
                title: title,
                items: items,
                sequency: this.user.sequency,
                action: () => {
                    this.navCtrl.push('ServicosPage', {}, { animate: true, direction: 'forward' });
                    this.currentPopover.dismiss();
                }
            },
            nav: this.navCtrl
        });

        this.currentPopover = newPopover;

        await newPopover.present({
            ev: event
        }).catch((error) => {
            console.table(error);
            return false;
        })
    }

    return() {
        this.playAnimation(this.initialVB, () => {
        this.areasGroup.style.display = "block";
        this.dotsGroup.style.display = "none";

            this.setInitials();
        });
        this.mapZoomed = false;
    }

    bindAreaEvents() {
        this.blocks = this.mapDOM.querySelectorAll('g[id="groups"] g[id^="area"]');
        this.dots = this.mapDOM.querySelectorAll('g[id="dots"] g[id^="dot_"]');
        if (this.blocks.length > 0) {
            this.blocks.forEach((item) => {
                item.addEventListener('click', (event) => { this.chooseArea(event, item) }, false);
            })

            console.log("blocks events binded");
        } else {
            console.log("no blocks found!");
        }

        if (this.dots.length > 0) {
            this.dots.forEach((item) => {
                let infos = item.id.split('_');
                item.addEventListener('click', (event) => { this.openDetail(event, infos[1], infos[2]) }, false);
            })

            console.log("dots events binded");
        } else {
            console.log("no dots found!");
        }

        this.startRefreshKiosks();
        this.refreshKiosks();
    }

    bindPinEvents() {
        // If browser supports pointer events
        // if (window.hasOwnProperty('PointerEvent')) {
        //     this.mapDOM.addEventListener('pointerdown', (event) => { this.onPointerDown(event) }, false); // Pointer is pressed
        //     this.mapDOM.addEventListener('pointerup', (event) => { this.onPointerUp() }, false); // Releasing the pointer
        //     this.mapDOM.addEventListener('pointerleave', (event) => { this.onPointerUp() }, false); // Pointer gets out of the SVG area
        //     this.mapDOM.addEventListener('pointermove', (event) => { this.onPointerMove(event) }, false); // Pointer is moving
        // } else {
            // Add all mouse events listeners fallback
            this.mapDOM.addEventListener('mousedown', (event) => { this.onPointerDown(event) }, false); // Pressing the mouse
            this.mapDOM.addEventListener('mouseup', (event) => { this.onPointerUp(event) }, false); // Releasing the mouse
            this.mapDOM.addEventListener('mouseleave', (event) => { this.onPointerUp(event) }, false); // Mouse gets out of the SVG area
            this.mapDOM.addEventListener('mousemove', (event) => { this.onPointerMove(event) }, false); // Mouse is moving

            // Add all touch events listeners fallback
            this.mapDOM.addEventListener('touchstart', (event) => { this.onPointerDown(event) }, false); // Finger is touching the screen
            this.mapDOM.addEventListener('touchend', (event) => { this.onPointerUp(event) }, false); // Finger is no longer touching the screen
            this.mapDOM.addEventListener('touchmove', (event) => { this.onPointerMove(event) }, false); // Finger is moving

            // this.mapDOM.addEventListener('click', (event) => { this.clickPrevent(event) }, false);
        // }

        this.setInitials();
    }

    setInitials() {
        // We save the original values from the viewBox
        this.viewBox = this.mapDOM.viewBox.baseVal;

        // Create an SVG point that contains x & y values
        this.point = this.mapDOM.createSVGPoint();
    }

    // This function returns an object with X & Y values from the pointer event
    getPointFromEvent(event) {
        // If even is triggered by a touch event, we get the position of the first finger
        if (event.targetTouches) {
            this.point.x = event.targetTouches[0].clientX;
            this.point.y = event.targetTouches[0].clientY;
        } else {
            this.point.x = event.clientX;
            this.point.y = event.clientY;
        }

        // We get the current transformation matrix of the SVG and we inverse it
        let invertedSVGMatrix = this.mapDOM.getScreenCTM().inverse();

        return this.point.matrixTransform(invertedSVGMatrix);
    }

    // Function called by the event listeners when user start pressing/touching
    onPointerDown(event) {
        this.isPointerDown = true; // We set the pointer as down

        // We get the pointer position on click/touchdown so we can get the value once the user starts to drag
        this.pointerOrigin = this.getPointFromEvent(event);
    }

    // Function called by the event listeners when user start moving/dragging
    onPointerMove(event) {
        // Only run this function if the pointer is down
        if (!this.isPointerDown) {
            return;
        }

        this.pointerMoved = true;

        // This prevent user to do a selection on the page
        event.preventDefault();

        // Get the pointer position as an SVG Point
        this.pointerPosition = this.getPointFromEvent(event);

        // Update the viewBox variable with the distance from origin and current position
        // We don't need to take care of a ratio because this is handled in the getPointFromEvent function
        let newPosX = this.viewBox.x - (this.pointerPosition.x - this.pointerOrigin.x);
        let newPosY = this.viewBox.y - (this.pointerPosition.y - this.pointerOrigin.y);
        let svgView = this.originalVB.split(' ');

        if (newPosX <= 0) {
            newPosX = 0;
        }
        if (newPosY <= 0) {
            newPosY = 0;
        }
        if (newPosX >= (parseFloat(svgView[2])-this.viewBox.width)) {
            newPosX = (parseFloat(svgView[2])-this.viewBox.width);
        }
        if (newPosY >= (parseFloat(svgView[3])-this.viewBox.height)) {
            newPosY = (parseFloat(svgView[3])-this.viewBox.height);
        }

        this.viewBox.x = newPosX;
        this.viewBox.y = newPosY;
    }

    onPointerUp(event) {
        // The pointer is no longer considered as down
        this.isPointerDown = false;

        if (this.pointerMoved) {
            event.preventDefault();
            this.pointerMoved = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/mapa/i-mapa/i-mapa.ts